import { RenrakuApi } from "@/api/RenrakuApi";
import { Renraku, RenrakuUser, RenrakuOptions, RenrakuList, SearchItem, RenrakuReadList, RenrakuDetail, RenrakuForList } from "@/types/KaisyaRenraku";

export class RenrakuService {

  /**
   * 会社連絡を新規登録します
   * @param params
   * @returns
   */
  public async createRenraku(params: Renraku): Promise<any> {
    const api = new RenrakuApi();
    try {
      return await api.createRenraku(params);
    } catch (e) {
      return null;
    }
  }

  public async getRenrakuList(): Promise<RenrakuForList[]> {
    const api = new RenrakuApi();
    try {
      return await api.getRenrakuList();
    } catch (e: any) {
      return [];
    }
  }

  public async searchUsers(): Promise<RenrakuUser[]> {
    const api = new RenrakuApi();
    try {
      return await api.getRenrakuUserList();
    } catch (e: any) {
      return [];
    }
  }

  public async getAllOptions(): Promise<RenrakuOptions> {
    const api = new RenrakuApi();
    try {
      return await api.getAllOptions();
    } catch (e) {
      throw e;
    }
  }

  public async getRenrakuListForSearch(serchItem: SearchItem): Promise<RenrakuList[]> {
    const api = new RenrakuApi();
    try {
      return await api.getRenrakuListForSearch(serchItem);
    } catch (e: any) {
      return [];
    }
  }

  public async getRenrakuDetail(oshiraseId: number): Promise<RenrakuDetail | null> {
    const api = new RenrakuApi();
    try {
      return await api.getRenrakuDetail(oshiraseId);
    } catch (e: any) {
      return null
    }
  }

  public async getRenrakuReadList(oshiraseId: number): Promise<RenrakuReadList[]> {
    const api = new RenrakuApi();
    try {
      return await api.getRenrakuReadList(oshiraseId);
    } catch (e: any) {
      return [];
    }
  }
}
